import { studentEventNotificationSchema } from "@vsta/contracts";
import type { StudentEventNotification } from "@vsta/contracts";

export type StudentSyncProjection = {
  lastSequence: number;
  aggregateRevision: number;
  status: "current" | "refresh-required" | "snapshot-required";
};

export function createStudentSyncProjection(
  authoritativeSequence: number,
): StudentSyncProjection {
  return {
    lastSequence: authoritativeSequence,
    aggregateRevision: authoritativeSequence,
    status: "current",
  };
}

export function applyStudentEventNotification(
  projection: StudentSyncProjection,
  input: StudentEventNotification,
): StudentSyncProjection {
  const event = studentEventNotificationSchema.parse(input);
  if (event.sequence <= projection.lastSequence) return projection;
  if (
    event.sequence !== projection.lastSequence + 1 ||
    event.baseRevision !== projection.aggregateRevision
  ) {
    return { ...projection, status: "snapshot-required" };
  }
  return {
    lastSequence: event.sequence,
    aggregateRevision: event.resultingRevision,
    status: "refresh-required",
  };
}

export function applyStudentSnapshotAnchor(
  _projection: StudentSyncProjection,
  authoritativeSequence: number,
): StudentSyncProjection {
  return createStudentSyncProjection(authoritativeSequence);
}
